import { FETCH_CSRF } from '../actions/Types'

const csrfReducer = (state=null, action) => {
    switch (action.type){
        case FETCH_CSRF:
            return action.payload
        default:
            return state
    }
}   

export default csrfReducer